import { ArrowLeft } from "@phosphor-icons/react";
import ContentContainer from "../components/ContentContainer";
import CreateEmissionsSourceWizard from "../components/CreateEmissionsSourceWizard/CreateEmissionsSourceWizard";
import IconButton from "../components/IconButton";
import MainLayout from "../components/MainLayout";
import Separator from "../components/Separator";
import Typography from "../components/Typography";
import { useNavigate } from "react-router-dom";
import { appPaths } from "../Routes";
import { CreateEmissionsSourceFormValues } from "../components/CreateEmissionsSourceWizard/FormValues";
import { useCreateEmissionsSource } from "../api/emissions-sources";
import { errorToast, successToast } from "../toast";
import { isMaterial } from "../constants";

const EmissionsSourceCreatePage = () => {
    const navigate = useNavigate();
    const [request, isSubmitting] = useCreateEmissionsSource();

    const handleSubmit = async (values: CreateEmissionsSourceFormValues) => {
        const emissionsSourceIsMaterial = values.isMaterial === isMaterial;
        const { categoryId, typeId, ...valuesToSubmit } = values;
        const response = await request({
            ...valuesToSubmit,
            isMaterial: emissionsSourceIsMaterial,
            dataStatusId: emissionsSourceIsMaterial
                ? values.dataStatusId
                : null,
            requiredEvidenceTypeIds: values.requiredEvidenceTypeIds
                .map((_) => _.value)
                .join(","),
        });

        if (!response.success) {
            errorToast(
                "There was a problem adding your asset - please try again"
            );
            return;
        }

        successToast("Asset added");
        navigate(appPaths.emissionsSources(emissionsSourceIsMaterial));
    };

    return (
        <MainLayout>
            <ContentContainer className="pt-14 pb-11">
                <div className="flex flex-col gap-6 sm:gap-0 sm:flex-row items-center pb-5">
                    <div className="flex items-center">
                        <IconButton
                            label="Back"
                            icon={ArrowLeft}
                            iconSize="large"
                            className="mr-3"
                            onClick={() => window.history.back()}
                        />
                        <Typography variant="headline-small" component="h1">
                            Add Asset Profile
                        </Typography>
                    </div>
                </div>
                <Separator className="mb-8" />
                <CreateEmissionsSourceWizard
                    onSubmit={handleSubmit}
                    onCancel={() => navigate(appPaths.emissionsSources(true))}
                    isSubmitting={isSubmitting}
                />
            </ContentContainer>
        </MainLayout>
    );
};

export default EmissionsSourceCreatePage;
